import $ from 'jquery'
import Cookies from 'js-cookie'

/**
 * Server Onboarding
 */
const Onboarding = {
  /**
   * The key used for storing the tab preference.
   * @type {String}
   */
  key: 'lang_pref',

  /**
   * Initialize
   *
   * @return {void}
   */
  init: function () {
    Onboarding.setupTabListener()
  },

  /**
   * Set up an event listener for tab change events.
   *
   * @return {void}
   */
  setupTabListener: function () {
    $(document).on('tab-changed', function (event) {
      // Validate that we care about this tab.
      if (event.tabContainer !== 'onboarding') {
        return
      }

      // Store the selected tab.
      Onboarding.storeTabPreference(event.tab)
    })
  },

  /**
   * Store the tab preference as a cookie.
   *
   * @param  {String} value The preferred tab.
   * @return {void}
   */
  storeTabPreference: function (value) {
    Cookies.set(Onboarding.key, value, { samesite: 'Lax' })
  },

  /**
   * Retrieve the tab preference cookie.
   *
   * @return {String}
   */
  loadTabPreference: function () {
    return Cookies.get(Onboarding.key)
  },
}

$(Onboarding.init)
